<template>
    <div class="app flex-row align-items-center login">
        <div class="container">
            <form v-on:submit.prevent="login">
                <b-row class="justify-content-center">
                    <b-col md="8">
                        <b-card-group>
                            <b-card no-body class="p-4">
                                <b-card-body>
                                    <h1>PA-SSQA</h1>
                                    <span>Phiên bản 3.1</span><br>
                                    <span style="color:red">{{ message }}</span>
                                    <p v-if="timeout" style="color: #f86c6b">{{ this.$route.params.content }}</p>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text>
                                                <i class="icon-user"></i>
                                            </b-input-group-text>
                                        </b-input-group-prepend>
                                        <input type="email" required="required" class="form-control"
                                            :placeholder="$t('login.input_text.email')" v-model="user.email">
                                    </b-input-group>
                                    <label for="name" style="color: red"
                                        v-if="errors.email">{{ errors.email ? errors.email[0] : '' }}</label>
                                    <b-input-group class="mb-3">
                                        <b-input-group-prepend>
                                            <b-input-group-text>
                                                <i class="icon-lock"></i>
                                            </b-input-group-text>
                                        </b-input-group-prepend>
                                        <input type="password" required="required" class="form-control"
                                            :placeholder="$t('login.input_text.password')" v-model="user.password">
                                    </b-input-group>
                                    <label for="password" style="color: red"
                                        v-if="errors.password">{{ errors.password ? errors.password[0] : '' }}</label>
                                    <b-form-group label-for="basicInlineRadios" :label-cols="3">
                                        <b-form-radio-group id="basicInlineRadios" :plain="true" v-model="user.type"
                                            :options="[
                                                { text: 'Người dùng nội bộ', value: '1' },
                                                { text: 'Người dùng bên ngoài', value: '2' }
                                            ]" :checked="2">
                                        </b-form-radio-group>
                                    </b-form-group>
                                    <b-row>
                                        <b-col cols="6">
                                            <b-button :disabled="btn_dangnhap" type="submit" variant="primary"
                                                class="px-4">Đăng nhập</b-button>
                                        </b-col>
                                        <b-col cols="6" class="text-right">
                                        </b-col>
                                    </b-row>
                                </b-card-body>
                            </b-card>
                            <b-card no-body class="text-white bg-primary py-3 ">
                                <b-card-body class="text-center">
                                    <div>
                                        <h3>PHẦN MỀM KIỂM TRA VÀ TUÂN THỦ CHẤT LƯỢNG</h3>
                                        <h6>CÔNG TY CỔ PHẦN NHIÊN LIỆU BAY PETROLIMEX</h6>
                                        <p>Trong trường hợp người dùng không đăng nhập được hệ thống, xin liên hệ qua
                                            địa chỉ email: cuongdm.pa@petrolimex.com.vn để được hỗ trợ.
                                        </p>
                                        <p>Xin trân trọng cảm ơn!</p>
                                    </div>
                                </b-card-body>
                            </b-card>
                        </b-card-group>
                    </b-col>
                </b-row>
            </form>
        </div>
    </div>
</template>
<script>
import Helper from '@/Helper'
import ProfileService from '@/service/profile'
import QrCode from '@/components/qr-code'
// import Echo from 'laravel-echo'
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'app-login',
  components: { QrCode, VueRecaptcha },
  props: [],
  data () {
    return {
      errors: [],
      message: '',
      user: {
        type: 1
      },
      btn_dangnhap: false,
      params: {},
      timeout: true
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   HTTP.get('/getuser').then(res => {
  //     next({path: '/'})
  //   }).catch(err => {
  //     console.log(err)
  //     next()
  //   })
  // },
  created () {
  },
  computed: {

  },
  mounted () {
    this.notifiResetPassword()
  },
  methods: {
    forgotPassword () {
      this.$router.replace('password/forgot')
    },
    notifiResetPassword () {
      // eslint-disable-next-line no-return-assign
      setTimeout(() => this.timeout = false, 5000)
    },
    login () {
      this.message = ''
      this.btn_dangnhap = true
      ProfileService.login(this.user).then(res => {
        if (res.status === 200) {
          Helper.setUserLocalStorage(res.data.data)
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect)
          } else {
            this.$router.push('/')
          }
          this.btn_dangnhap = false
        }
      }).catch(err => {
        console.log(err.message)
        this.message = err.data.message

        if (err.status === 422) {
          this.errors = err.data.message
        }
        if (err.status === 401) {
          this.message = 'Đăng nhập thất bại'
        }
        this.btn_dangnhap = false
      })
    },
    getCaptcha (response) {
      this.user.captcha = response
    }
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/login/index.vue